import ArticleCard from '@/components/feature/ArticleCard';
import { featuredArticles } from '@/mocks/articles';

export default function FeaturedSection() {
  const featured = featuredArticles.slice(0, 4);

  return (
    <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-1">
              精选推荐
            </h2>
            <p className="text-sm text-foreground-500">编辑团队每日精选优质同人内容</p>
          </div>
          <div className="hidden sm:flex items-center gap-1">
            <span className="w-8 h-8 flex items-center justify-center rounded-full bg-accent-100 text-accent-600">
              <i className="ri-star-fill text-sm"></i>
            </span>
            <span className="text-xs text-foreground-500">每日精选</span>
          </div>
        </div>
        <div
          className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5"
          data-product-shop
        >
          {featured.map((article) => (
            <ArticleCard key={article.id} article={article} />
          ))}
        </div>
      </div>
    </section>
  );
}